
























import { Component, Vue, Prop ,Inject} from 'vue-property-decorator'
import { searchToWhereUrl } from '@core/utils/jump'
import { isHzwApp, isRkhy } from '@utils/cookie'
@Component({
  filters: {
    distanceStr(distance: string) {
      if(!distance) return ''
      return +distance > 60 ? '>60km' : `${distance}km`
    }
  }
})
export default class ConsultantItem extends Vue {
  @Prop({ default: () => ({}) }) readonly value!: any

  @Inject('pageTrackParams')
  pageTrackParams!: any
  @Inject('clickid_200007')
  clickid_200007!: string

  get goDetail() {
    //育儿顾问与月嫂地址相同
    return searchToWhereUrl({ toYuesao: true, uid: this.value.uid })
  }
  get goDetailExposure() {
    return `${this.clickid_200007}||${JSON.stringify({ name:this.value.workerName})}`
  }
  goDetailClick() {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_200007, positionParam: { name:this.value.workerName} })
  }

  get isShowIm(){
    return isHzwApp() || isRkhy()
  }

  toIM() {
    if (isHzwApp() || isRkhy()) {
      if (+this.value.userType === 1) {
        location.href = `//im.cekid.com/shequ/chat/?targetId=${this.value.uid}&cmd=imconversation&scenetype=11&userid=${this.value.uid}&refresh=no`
      } else {
        location.href = `http://a.app.qq.com/o/simple.jsp?pkgname=com.kidswant.ss&cmd=usercard&userid=${this.value.uid}`
      }
    } else {
      location.href = `http://a.app.qq.com/o/simple.jsp?pkgname=com.kidswant.ss&cmd=usercard&userid=${this.value.uid}`
    }
  }
}
